import { Routes, provideRouter, withViewTransitions } from '@angular/router';
import { provideZoneChangeDetection } from '@angular/core';
import { providePrimeNG } from 'primeng/config';
import { provideFormFactoryConfig } from 'ngx-dynamic-forms-factory';
import { ConfirmationService, MessageService } from 'primeng/api';
import { provideIcons } from '@ng-icons/core';

import { provideHttpClient } from '@angular/common/http';
import { ICONS, provideEnvironment } from 'libs/core/src/public-api';
import {
  MissingTranslationHandler,
  provideTranslateService,
} from '@ngx-translate/core';
import {
  FormFactoryOptions,
  CustomMissingTranslationHandler,
} from 'libs/core/src/public-api';
import { AppTheme } from './theme/theme';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ToastService } from 'libs/core/src/public-api';
import { environment } from '../../environments/environment';
// import { provideAbilities } from './permissions/abilities';
export interface CoreOptions {
  routes: Routes;
}

export function provideCore({ routes }: CoreOptions) {
  return [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withViewTransitions()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: AppTheme,
        options: {
          darkModeSelector: 'dark',
        },
      },
    }),
    provideTranslateService({
      fallbackLang: 'sr',
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CustomMissingTranslationHandler,
      },
    }),
    provideFormFactoryConfig(FormFactoryOptions),
    provideHttpClient(),
    provideIcons(ICONS),
    // provideAbilities(),
    ConfirmationService,
    MessageService,
    ToastService,
    provideEnvironment(environment),
  ];
}
